import { createSlice } from '@reduxjs/toolkit';

export const onlyFansConnectionsSlice = createSlice({
  name: 'onlyFansConnections',
  initialState: {
    connections: [],
  },

  reducers: {
    setConnections: (state, action) => {
      state.connections = action.payload;
    },

    addConnection: (state, action) => {
      const exists = state.connections.some(conn => conn.id === action.payload.id);

      state.connections = exists
        ? state.connections.map(conn => (conn.id === action.payload.id ? action.payload : conn))
        : [...state.connections, action.payload];
    },

    updateConnection: (state, action) => {
      state.connections = state.connections.map(conn =>
        conn.id === action.payload.id ? { ...conn, ...action.payload } : conn
      );
    },

    removeConnection: (state, action) => {
      state.connections = state.connections.filter(
        connection => connection.id !== action.payload.id
      );
    },
  },
});

export const {
  setConnections,
  addConnection,
  updateConnection,
  removeConnection,
} = onlyFansConnectionsSlice.actions;

export default onlyFansConnectionsSlice.reducer;
